import { Modal, Stack, Text, Textarea } from "@mantine/core"
import { useForm } from "@mantine/form"
import { Button, InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { UpdateCertificateRequestRequestDto } from "~/gen/api"

type Props = {
  opened: boolean
  onClose: () => void
  onSubmit: (values: UpdateCertificateRequestRequestDto) => void
  isSubmitting: boolean
}

export function RejectionModal({
  opened,
  onClose,
  onSubmit,
  isSubmitting,
}: Props) {
  const { t } = useTranslation("certificates")

  const form = useForm<UpdateCertificateRequestRequestDto>({
    initialValues: {
      rejectionMessage: "",
      status: "REJECTED",
    },
  })

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("modal.rejectModal.title")}
    >
      <Stack>
        <InfoBox
          variant="warning"
          message={t("modal.rejectToolTips")}
          size="xs"
        />
        <Text>{t("modal.rejectModal.subtitle")}</Text>

        <form onSubmit={form.onSubmit(onSubmit)}>
          <Stack>
            <Textarea
              size="xs"
              label={t("modal.labels.rejectionMessage")}
              placeholder={t("modal.placeholders.rejectionMessage")}
              withAsterisk={true}
              styles={{
                input: {
                  backgroundColor: "white",
                  border: "1px solid var(--mantine-color-primary-1)",
                },
              }}
              {...form.getInputProps("rejectionMessage")}
            />
            <Button
              fullWidth={true}
              variant="primary-critical"
              type="submit"
              loading={isSubmitting}
            >
              {t("modal.rejectModal.submit")}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Modal>
  )
}
